export default "__VITE_ASSET__fe8404fe__"